export const jpgPath = (
  assetId: string,
  width: number,
  height: number,
  parameters = '',
) => {
  if (!(assetId.startsWith('image_') || assetId.startsWith('video_'))) {
    return `https://imf.mewa.de/im/imf/${assetId}/f,j/s,x,${width},y,${height}`;
  }

  return `https://d1u1vozjf6xtm0.cloudfront.net/image/794933937620/${assetId}/-S${width}x${height}-FJPG${parameters}`;
};

export const videoPath = (assetId: string) => {
  // TODO: Find out what to do if assetId does not start with 'video_'? Workaround similar to image doesnt work.
  return `https://d1u1vozjf6xtm0.cloudfront.net/asset/794933937620/${assetId}`;
};

export const clothingCardImages = (assetId: string) => [
  {
    src: jpgPath(assetId, 552 * 1.5, 607 * 1.5),
    media: '',
    width: 552,
    height: 607,
  },
];

const fourByThreeCardImages = (assetId: string) => [
  {
    src: jpgPath(assetId, 552 * 2, 414 * 2),
    media: '',
    width: 552,
    height: 414,
  },
];

export const nonClothingCardImages = fourByThreeCardImages;
export const industryCardImages = fourByThreeCardImages;
